// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KKHAn","content":"styles_content__1siQ_"};